"use client";
import "../../chunk-MMUBH76A.js";
import { isAndroid, isMobile, isTelegram } from "@getpara/web-sdk";
const routeMobileExternalWallet = (qrUri) => {
  if (typeof window === "undefined") {
    return;
  }
  if (isMobile()) {
    if (!qrUri) return;
    if (!isTelegram() && qrUri.startsWith("http")) {
      const link = document.createElement("a");
      link.href = qrUri;
      link.target = "_blank";
      link.rel = "noreferrer noopener";
      link.click();
    } else {
      if (isTelegram()) {
        let href = qrUri;
        if (isAndroid()) {
          href = encodeURI(qrUri);
        }
        window.open(href, "_blank", "noreferrer noopener");
      } else {
        window.location.href = qrUri;
      }
    }
  }
};
export {
  routeMobileExternalWallet
};
